<script setup lang="ts">
// Atlas Mark A — screen + play triangle + stand line (brand glyph).
// Inline SVG so the triangle can pick up the live `--accent` token; reads at
// 16px (verified small per spec §6 #10). Decorative — aria-hidden; the
// accessible name lives on the adjacent Wordmark text.

withDefaults(defineProps<{ size?: number; color?: string }>(), { size: 28 });
</script>

<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 64 64"
        fill="none"
        aria-hidden="true"
        focusable="false"
        class="atlas-mark"
    >
        <rect x="10" y="14" width="44" height="32" rx="7" stroke="var(--border)" stroke-width="2" />
        <path d="M28 25 L40 30 L28 35 Z" :fill="color ?? 'var(--accent)'" />
        <path d="M24 52 H40" stroke="var(--border)" stroke-width="2.4" stroke-linecap="round" />
    </svg>
</template>

<style scoped>
.atlas-mark {
    display: block;
    flex: 0 0 auto;
}
</style>
